import { keychain } from '../api/keychain'
import { useAppStore } from './app'
import { bridge } from '../bridge'

/// Reads keychain for existing enrollment + asks the bridge for current
/// subscription state before first render. Called from main.tsx so the
/// first frame already reflects real state (no flash of registration UI
/// for returning users).
export async function bootstrapRegistration(): Promise<void> {
  try {
    const [ioDeviceID, humanUserID, organizationID, email, status] =
      await Promise.all([
        keychain.ioDeviceID(),
        keychain.humanUserID(),
        keychain.organizationID(),
        keychain.email(),
        bridge.call('storekit.status'),
      ])
    useAppStore.getState().setSubscribed(status.subscribed)
    // Registration is proven by device credentials, NOT by having a
    // household. A device can be validly enrolled with no current org:
    // an invitee who deferred org assignment, or a user whose last
    // household was archived. Requiring organizationID here meant any
    // refresh in that state kicked the user back to the login screen even
    // though their device was fully enrolled — the org-less state is
    // resolved by OrphanedScreen once organizations_list lands, not by
    // pretending the device isn't registered.
    if (ioDeviceID && humanUserID) {
      useAppStore.getState().setRegistered({
        ioDeviceID,
        humanUserID,
        organizationID: organizationID ?? '',
        email,
      })
    }
  } catch (err) {
    // Bootstrap failures are non-fatal — user sees the registration
    // screen and any real issue will show up there. Log for debugging.
    console.warn('bootstrap:', err)
  }
}
